import { GqlLanguages, MdUpdateUserInput } from '@anyx/common-graphql';
import { Self } from '@anyx/common-self';

export const updateUserSelfAdapter = {
  toGQL: (data: Self): MdUpdateUserInput => {
    return {
      ...data,
      language: GqlLanguages.asUserLanguage(data.language),
    };
  },
};
